export enum CmsButtonTypeEnum {
  ARCHIVE = 'archive',
  CREATE = 'create',
  CLONE = 'clone',
  EDIT = 'edit',
  PUBLISH = 'publish',
}
